(function($){
	function updateFieldState(input){
		var field = input.closest(".dogtopia-newsletter-signup-field");
		if(!field) return;

		if(input.value && input.value.trim() !== ""){
			field.classList.add("has-focus-or-value");
		}else{
			field.classList.remove("has-focus-or-value");
		}
	}

	function setSubmittingState(form, isSubmitting){
		var submitButton = form.querySelector(".dogtopia-newsletter-signup-actions button[type='submit']");
		var spinner = form.querySelector(".dogtopia-newsletter-signup-button-spinner");
		if(!submitButton) return;

		submitButton.disabled = isSubmitting;

		if(isSubmitting){
			submitButton.classList.add("is-submitting");
			submitButton.setAttribute("aria-busy", "true");
		}else{
			submitButton.classList.remove("is-submitting");
			submitButton.removeAttribute("aria-busy");
		}

		if(spinner){
			spinner.style.display = isSubmitting ? "block" : "none";
		}
	}

	function getNoticeElement(form){
		var formContainer = form.closest(".header-newsletter-inline-form, .dogtopia-footer-signup-inner, .dogtopia-footer-signup");
		var notice = formContainer ? formContainer.querySelector(".dogtopia-newsletter-signup-notice") : null;

		if(!notice && formContainer){
			notice = document.createElement("div");
			notice.className = "dogtopia-newsletter-signup-notice";
			formContainer.insertBefore(notice, form);
		}

		return notice;
	}

	function renderNotice(form, status, message){
		var notice = getNoticeElement(form);
		if(!notice) return;

		notice.classList.remove("is-success", "is-error");
		notice.classList.add(status === "success" ? "is-success" : "is-error");
		notice.textContent = message;
		notice.hidden = false;
	}

	function resetFieldStates(form){
		var fields = form.querySelectorAll(".dogtopia-newsletter-signup-field");
		fields.forEach(function(field){
			field.classList.remove("is-focused", "has-focus-or-value");
		});
	}

	function formatPhoneNumber(value){
		var digits = value.replace(/\D/g, "").slice(0, 10);
		var areaCode = digits.slice(0, 3);
		var prefix = digits.slice(3, 6);
		var lineNumber = digits.slice(6, 10);

		if(digits.length > 6){
			return "(" + areaCode + ")-" + prefix + "-" + lineNumber;
		}

		if(digits.length > 3){
			return "(" + areaCode + ")-" + prefix;
		}

		if(digits.length > 0){
			return "(" + areaCode;
		}

		return "";
	}

	function applyPhoneMask(input){
		var formattedValue = formatPhoneNumber(input.value);

		if(input.value !== formattedValue){
			input.value = formattedValue;
		}

		updateFieldState(input);
	}

	/**
	 * Document listener for the footer/newsletter forms.
	 * - add/remove class to input fields
	 * - display spinner on form submit
	 * - submit forms through ajax without page reload
	 */
	document.addEventListener("DOMContentLoaded", function(){
		var inputs = document.querySelectorAll(".dogtopia-newsletter-signup-field input");
		var forms = document.querySelectorAll(".dogtopia-newsletter-signup-form");

		inputs.forEach(function(input){
			updateFieldState(input);

			if(input.matches("input[name='phone']")){
				applyPhoneMask(input);
			}

			input.addEventListener("focus", function(){
				var field = input.closest(".dogtopia-newsletter-signup-field");
				if(field) field.classList.add("is-focused");
			});

			input.addEventListener("blur", function(){
				var field = input.closest(".dogtopia-newsletter-signup-field");
				if(field) field.classList.remove("is-focused");
				updateFieldState(input);
			});

			input.addEventListener("input", function(){
				if(input.matches("input[name='phone']")){
					applyPhoneMask(input);
					return;
				}

				updateFieldState(input);
			});
		});

		forms.forEach(function(form){
			form.addEventListener("submit", function(event){
				var ajaxEndpoint = form.getAttribute("action");
				var submitButton = form.querySelector(".dogtopia-newsletter-signup-actions button[type='submit']");
				var formData;

				event.preventDefault();

				if(!ajaxEndpoint || !submitButton){
					return;
				}

				if(submitButton.disabled){
					return;
				}

				formData = new FormData(form);
				if(!formData.get("action")){
					formData.set("action", "dogtopia_newsletter_signup_submit_ajax");
				}
				setSubmittingState(form, true);

				fetch(ajaxEndpoint, {
					method: "POST",
					body: formData,
					credentials: "same-origin"
				})
				.then(function(response){
					return response.json().catch(function(){
						return {
							success: false,
							data: {
								status: "error",
								message: "Something went wrong while submitting. Please try again."
							}
						};
					});
				})
				.then(function(payload){
					var isSuccess = !!payload.success;
					var data = payload.data || {};
					var message = data.message || (isSuccess ? "Thanks for signing up." : "Something went wrong while submitting. Please try again.");

					// if(data.debug_payload){
					// 	console.log("Dogtopia splash page payload", data.debug_payload);
					// }

					renderNotice(form, isSuccess ? "success" : "error", message);

					if(isSuccess){
						form.reset();
						resetFieldStates(form);
					}
				})
				.catch(function(){
					renderNotice(form, "error", "Something went wrong while submitting. Please try again.");
				})
				.finally(function(){
					setSubmittingState(form, false);
				});
			});
		});
	});
})(jQuery);
